// OPEN CONFIGURATOR
// RESPONSIVE VIDEO!
// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// LAYERS (SWIPER JS + GSAP)
// PAUSE OUT-OF-VIEW VIDEO
// PRODUCT PICKER
// NEWSLETTER PICKER


//
// =OPEN CONFIGURATOR
// --------------------------------------------------

if (window.location.href.indexOf('#openConfigurator') > -1) {
  window.openJacketConfigurator();
}

window.addEventListener('load', () => {
  if (window.location.href.indexOf('#openConfigurator') > -1) {
    $("html, body").animate({scrollTop: $('#openConfigurator').offset().top }, 900);
  }
});

document.querySelectorAll('.msdw-open-configurator-btn').forEach(el => {
  el.addEventListener('click', () => window.openJacketConfigurator())
});


//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById('msdw-video-responsive');

function loadVideo() {
  var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
      md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
      lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
      xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if      (sm.matches) { changeVideoSize('sm') }
  else if (md.matches) { changeVideoSize('md') }
  else if (lg.matches) { changeVideoSize('lg') }
  else if (xl.matches) { changeVideoSize('xl') }
}

function changeVideoSize(size){
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-"+size));
  vid.autoplay = true;
  vid.load();
  // console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener('DOMContentLoaded', loadVideo);
  window.onresize = loadVideo;
  vid.onloadeddata = () => vid.classList.add('msdw-video-loaded');
}

// window.addEventListener('resize', () => vid.attr('hidden' = true));


//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// $('.msdw-page-scroll').click(function() {
//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       var offsetValue = 0;
//       if ( window.innerWidth <= 767 ) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $('html,body').animate({
//         scrollTop: target.offset().top - offsetValue
//       }, 900);
//       return false;
//     }
//   }
// });


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));


//
// =LAYERS (SWIPER JS + GSAP)
// --------------------------------------------------

// window.addEventListener('DOMContentLoaded', () => {
  const sliderLayers = new Swiper("#sliderLayers", {
    spaceBetween: 0,
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 50,
    loop: false,
    noSwipingClass: "no-swipe",
  });

  gsap.registerPlugin(ScrollTrigger);

  const tl = gsap.timeline({
    paused: true,
    defaults: {
      ease: Linear.easeNone,
    },
    scrollTrigger: {
      trigger: ".msdw-section-layers",
      scrub: 0.5,
      pin: true,
      pinSpacing: true,
      start: "top top",
      // end: "+=333%",
      end: window.innerHeight * 3,
      invalidateOnRefresh: true,
    },
  });

  tl.to({}, {duration: 3});
  tl.call(() => sliderLayers.slideTo(0));
  tl.to({}, {duration: 3});
  tl.call(() => sliderLayers.slideTo(1));
  tl.to({}, {duration: 3});
  tl.call(() => sliderLayers.slideTo(2));
  tl.to({}, {duration: 3});

  const configBannerTL = gsap.timeline({
    scrollTrigger: {
      trigger: '.msdw-configurator-banner',
      start: 'top bottom',
      end: 'bottom top',
      scrub: 1,
    }
  });

  configBannerTL.fromTo('.msdw-configurator-banner', { y: "-10%" }, { y: "10%" });

  const sepBannerTL = gsap.timeline({
    scrollTrigger: {
      trigger: '.msdw-zoom-in-anim',
      start: 'top 85%',
      once: true,
    }
  });

  sepBannerTL.from('.msdw-zoom-in-anim', 1, { scale: 1.2 });
// });


//
// =PAUSE OUT-OF-VIEW VIDEO
// --------------------------------------------------

const videos = document.querySelectorAll("video");

const config = {
  rootMargin: '-100px 0px',
  threshold: 0
}

const callbackVids = (entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      entry.target.pause();
      console.log('Exit video');
    } else {
      entry.target.play();
      console.log('Enter video');
    }
  });
}

const observerVids = new IntersectionObserver(callbackVids, config);

videos.forEach( vid => observerVids.observe(vid) );



//
// =PRODUCT PICKER
// --------------------------------------------------

// const productPickers = document.querySelectorAll('.msdw-product-detail-picker');

// productPickers.forEach(productPicker => {
//   const productIdNumber = productPicker.dataset.productId;
//   productPicker.addEventListener('click', (e) => {
//     e.preventDefault();
//     window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {
//       'productId': productIdNumber
//     });
//   });
// });


//
// =NEWSLETTER PICKER
// --------------------------------------------------

// var campaignId = 'familyAndFriends',
//     pickerTag = document.getElementById("openPicker"),
//     newsletterConfig = {},
//     baseUrl = jwsdwSettings.baseUrl;

// $.ajax({
//   type: 'GET',
//   url: baseUrl + '/Newsletter-getNewsletterConfig',
//   data: {
//     campaignId: campaignId
//   },
//   success: function(response) {
//     newsletterConfig = response
//   },
//   error: function(response) {
//     jwsdwApi.popup.showHttpError(response.status)
//   }
// });

// pickerTag.addEventListener("click", function(){
//   window.jwsdwMediator.publish('openPicker', 'newsletterSignupPicker', {
//     "campaign": newsletterConfig.id,
//     "introduction": newsletterConfig.introduction,
//     "disclaimerOne": newsletterConfig.disclaimerOne,
//     "disclaimerTwo": newsletterConfig.disclaimerTwo
//   });
// });
